import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  path: (
    <path
      d='M19.25 19.25L15.5 15.5L19.25 19.25ZM4.75 11C4.75 7.54822 7.54822 4.75 11 4.75C14.4518 4.75 17.25 7.54822 17.25 11C17.25 14.4518 14.4518 17.25 11 17.25C7.54822 17.25 4.75 14.4518 4.75 11Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ),
  defaultProps: defaultProps
})
